/*
 * UserEditForm Messages
 *
 * This contains all the text for the UserEditForm component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.UserEditForm";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the UserEditForm component!",
  },
  changeUserInfo: {
    id: `${scope}.changeUserInfo`,
    defaultMessage: "Change user information",
  },
});
